<template>
  <div class="wrap-info">
    <div v-show="!infoDetaillVis" class="container">
      <div class="close-icon" @click="closeHandle"><span class="el-icon-close"></span></div>
      <ul ref="infoList" class="infoList">
        <li v-for="(item,index) in infoList" :key="index" class="infoListItem" @click="selectInfo(item.inforId)">
          <div class="left">
            <div class="title">{{ item.title }}</div>
            <div class="abstract">{{ item.summary }}
            </div>
            <div class="footer">
              <div class="source">信息来源：{{ item.inforSource }}</div>
              <div class="time">发布时间：{{ item.createTime }}</div>
            </div>
          </div>
          <div class="right">
            <img :src="item.thumbnail ? item.thumbnail:'/images/preloader/thumbnail1.png'" alt="">
          </div>
          <img v-if="index !== infoList.length - 1" class="line" src="/images/preloader/line_02.png" alt="">
        </li>
      </ul>
      <div class="btn-group">
        <div class="flip">
          <div style="margin: 0 20px 0 0;" @click="scrollHandle('up','infoList',680)"><img src="/images/preloader/icon-up.png" alt=""><span>上翻</span></div>
          <div @click="scrollHandle('down','infoList',680)"><img src="/images/preloader/icon-down.png" alt=""><span>下翻</span></div>
        </div>
        <div class="close" style="margin: 0 0 0 40px;" @click="closeHandle"><img src="/images/preloader/icon_foot_close.png" alt=""><span>关闭</span></div>
      </div>
    </div>
    <!-- 资讯详情 -->
    <div v-if="infoDetaillVis" class="info-detail-mask">
      <div class="info-detail">
        <div class="close-icon" @click="closeHandle"><span class="el-icon-close"></span></div>
        <div ref="infoDetaillMain" class="main">
          <div class="header">
            <div class="title">
              {{ infoDetaill.title }}
            </div>
            <div class="info">
              <div class="source">信息来源：{{ infoDetaill.inforSource }}</div>
              <div class="time">发布时间：{{ infoDetaill.createTime && $moment(infoDetaill.createTime).format('YYYY/MM/DD HH:mm:ss') }}</div>
            </div>
          </div>
          <div class="content">
            <div class="description initialOrignUlLi" v-html="infoDetaill.infoContent"></div>
          </div>
        </div>
        <div class="btn-group">
          <div class="flip">
            <div @click="scrollHandle('up','infoDetaillMain',520)"><img src="/images/preloader/icon-up.png" alt=""><span>上翻</span></div>
            <div @click="scrollHandle('down','infoDetaillMain',520)"><img src="/images/preloader/icon-down.png" alt=""><span>下翻</span>
            </div>
          </div>
          <div class="opera">
            <div @click="infoDetaillVis = !infoDetaillVis"><img src="/images/preloader/icon-left.png" alt=""><span>后退</span></div>
            <div @click="closeHandle"><img src="/images/preloader/icon_foot_close.png" alt=""><span>关闭</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      infoDetaillVis: false,
      infoList: [],
      infoDetaill: {}
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    }
  },
  created () {
    this.getHospitalInfoList();
  },
  methods: {
    async selectInfo (inforId) {
      try {
        this.infoDetaill = await this.getHospitalInfoDetail(inforId);
        this.infoDetaillVis = true;
      } catch (error) {
        console.error('查看详情报错信息:', error);
      }
    },
    closeHandle () {
      this.$emit('close');
    },

    // 上翻下翻
    scrollHandle (type, dom, rollDtance) {
      this.$nextTick(() => {
        console.log(this.$refs[dom]);
        let domNode = this.$refs[dom];
        console.log(domNode.scrollTop, type);
        let scrollTop = domNode.scrollTop;
        if (type === 'up') {
          domNode.scrollTop = scrollTop - rollDtance;
        } else {
          domNode.scrollTop = scrollTop + rollDtance;
        }
        console.log(this.$refs.infoList.scrollTop, type);
      });
    },
    // 获取文章列表
    async getHospitalInfoList () {
      try {
        let data = await this.$apis.third.getHospitalInfoList({
          limit: '1000',
          page: '1',
          buildId: this.buildInfo.buildId // 建筑Id
        });
        let res = JSON.parse(data.data);
        console.log('获取文章列表', res);
        this.infoList = res.list;
      } catch (error) {
        this.infoList = [];
        console.error('获取文章列表报错:', error);
      }
    },
    // 获取文章详情
    async getHospitalInfoDetail (inforId) {
      try {
        let data = await this.$apis.third.getHospitalInfoDetail({
          inforId// 信息Id
        });
        let res = JSON.parse(data.data);
        console.log('获取文章详情', res);
        return res;
      } catch (error) {
        console.error('获取文章详情报错:', error);
        return {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap-info {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: $color-opacity-regular;
  background-size: 100% 100%;
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 819px;
    width: 1454px;
    transform: translate(-50%, -50%);
    background-image: url("/images/preloader/bg-symptom5.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // display: flex;
    padding: 38px;
    box-sizing: border-box;
    color: $color-white;
    .infoList{
      height: 620px;
      overflow: auto;
      .infoListItem{
        display: flex;
        flex-wrap: wrap;
        & > div{
          height: 160px;
        }
        .left{
          width: 1110px;
          text-align: left;
          padding-right: 40px;
          box-sizing: content-box;
          .title{
            margin-bottom: 20px;
            font-size: 26px;
            color: #fff;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .abstract{
            font-size: 20px;
            margin-bottom: 28px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 30px;
            font-weight: 300;

          }
          .footer{
            display: flex;
            margin-bottom: 40px;
            font-size: 14px;
            color:  #ccc;
            .source{
              margin-right: 100px;
            }
            .time{
            }
          }
        }
        .right{
          flex: 1;
          // width: 264px;
          img{
            width: 100%;
            height: 155px;
            border-radius: 10px;
          }
        }
        .line{
          width: 100%;
          height: 1px;
          margin: 38px 0;
        }
      }
    }
    .btn-group{
      display: flex;
      height: 140px;
      justify-content: space-between;
      align-items: center;
      & > .flip {
        display: flex;
        // height: 140px;
        align-items: center;
        justify-content: center;
         & > div {
          width: 100px;
          height: 40px;
          background: #3a6191;
          box-shadow: 0 0 10px $color-opacity-primary;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          border-radius: 50px;
          // margin: 0 40px 0 0;
          color: $color-white;
          // color: #fff;
        }
        img {
          margin: 0 10px 0 0;
          width: 24px;
        }
      }
      & > .close {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
       img {
         margin: 0 20px 0 0;
         width: 24px;
       }
      }

    }
  }
  .info-detail-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: $color-opacity-primary;
    z-index: 999999;
    .info-detail {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1450px;
      height: 819px;
      transform: translate(-50%, -50%);
      background: url("/images/preloader/bg-symptom3.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      padding: 45px 38px 36px 38px;
      box-sizing: border-box;
      flex-direction: column;
      text-align: left;
      color: $color-white;
      .main{
         overflow: auto;
        & > .header {
          height: 80px;
          margin: 0 0 30px 0;
          // height: 40px;
          > .title{
            margin-bottom: 26px;
            font-size: 32px;
            color: #fff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > .info{
            display: flex;
            font-size: 18px;
            color:  #ccc;
            .source{
              margin-right: 100px;
            }
          }
        }
        & > .content {
          height: 520px;
          width: 100%;
          // font-size: 24px;
          // text-indent: 2em;
        }
      }

      .btn-group {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        & > div{
           display: flex;
        }
        img {
          width: 24px;
        }
        .flip{
          & > div {
            width: 100px;
            height: 40px;
            background: #3a6191;
            box-shadow: 0 0 10px $color-opacity-primary;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            border-radius: 50px;
            // margin: 0 40px 0 0;
            // color: $color-white;
            color: #ccc;
          }
        }
        .opera{
          width: 400px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          & > div {
            width: 180px;
            height: 60px;
            background: #3a6191;
            box-shadow: 0 0 10px $color-opacity-primary;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 26px;
            border-radius: 50px;
            color: $color-white;
            img{
              margin-right: 14px;
              width: 24px;
            }
          }
        }

      }
    }
  }
  .close-icon {
    display: none;
  }
}
@media (orientation: portrait) {
  .wrap-info {
    .container {
      height: 68vh;
      // background-size: auto 100%;
      background: rgba(46,90,141,0.94);
      // background: linear-gradient(rgba(46,90,141,0.94), rgba(44,88,139,0.99));
      border-radius: 20px;
      .btn-group {
        .close {
          // display: none;
          img {
            width: 24px;
          }
        }
        .flip {
          width: 300px;
          & > div {
            width: 120px;
            height: 50px;
            font-size: 20px;
          }
        }
      }
      .infoList {
        height: calc(100% - 120px);
        .infoListItem {
          .line {
            margin: 30px 0;
          }
          .left {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              margin-bottom: 0;
              font-size: 32px;
            }
            .abstract {
              margin: 0;
              font-size: 28px;
            }
            .footer {
              margin-bottom: 0;
              font-size: 28px;
            }
          }
        }
      }
    }
    .close-icon {
        display: block;
        position: absolute;
        top: -60px;
        right: 0;
        font-size: 38px;
        color: #ccc;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 2px solid #ccc;
        padding: 0;
        font-weight: bold;
        box-sizing: border-box;
      }
    .info-detail-mask {
      .info-detail {
        background: rgba(46,90,141,0.94);
        border-radius: 20px;
        // background: linear-gradient(rgba(46,90,141,0.94), rgba(44,88,139,0.99));
        height: 68vh;
        .main {
          height: 100%;
          .header {
            font-size: 28px;
          }
          .title {
            font-size: 32px;
          }
          .info {
            font-size: 28px;
            .source {
              font-size: 24px;
            }
          }
          .content {
            height: 100%;
            font-size: 28px;
          }
        }
        .btn-group {
          .close {
            display: none;
          }
          .flip {
            width: 300px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            & > div {
              width: 120px;
              height: 50px;
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
